export const ORGANIZATION_REQUESTED = 'ORGANIZATION_REQUESTED'
export const ORGANIZATION_RECEIVED = 'ORGANIZATION_RECEIVED'
export const ORGANIZATION_SETTINGS_REQUESTED = 'ORGANIZATION_SETTINGS_REQUESTED'
export const ORGANIZATION_SETTINGS_RECEIVED = 'ORGANIZATION_SETTINGS_RECEIVED'
export const ORGANIZATION_UMBRELLAS_RECEIVED = 'ORGANIZATION_UMBRELLAS_RECEIVED'
export const ORGANIZATION_UMBRELLAS_REQUESTED = 'ORGANIZATION_UMBRELLAS_REQUESTED'
export const IS_TRUSTED_PARTNER_REQUESTED = 'IS_TRUSTED_PARTNER_REQUESTED'
export const IS_TRUSTED_PARTNER_RECEIVED = 'IS_TRUSTED_PARTNER_RECEIVED'
